// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3hr-A","error":"Textarea_error__7fdgR","readonly":"Textarea_readonly__JY3yn","disabled":"Textarea_disabled__3I7b1"};